import "./pages/auth/Auth.css";

export default function PasswordBox(props) {

    return <>
        <label htmlFor="password-reenter">
            {`Enter your ${props.resetPassword ? "current" : ""} password to confirm:`}
        </label>

        <input
            id="password-reenter"
            style={{ width: 300 }}
            className="auth-input"
            type="password"
            autoComplete="password"
            value={props.password}
            onChange={(e) => {
                props.onChange(e.target.value);
            }}
        />
    </>
}